<template>
  <div id="app"  >
    <transition name="el-fade-in" mode="out-in"><router-view></router-view></transition>
  </div>
</template>

<script type="text/ecmascript-6">
    // import axios from 'axios';
    export default {
        data(){
            return {

                seller: {}
            }
        },
        name: 'app'
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../static/css/main.css";
  /*@import "../static/css/color-dark.css";     !*深色主题*!*/
  /*@import "../static/css/theme-green/color-green.css";   !*浅绿色主题*!*/
</style>




// WEBPACK FOOTER //
// src/App.vue